import React, { memo } from 'react';
import { connect } from 'react-redux';

import { cardPaseAnualSelector, cardMovieYelmoSelector } from '../selectors';

const PriceZero = ({ cardImage, cardName, cardNumber }) => {
  return (
    <div className="payment__method-box price-zero">
      <figure className="price-zero__img">
        <img src={cardImage !== '' ? cardImage : require(`../static/images/bg-folio-big.png`)} alt="" />
        <figcaption className="price-zero__num">
          {cardNumber?.map((num, i) => <span key={`${num}-${i}`}>{num}</span>)}
        </figcaption>
      </figure>

      <p className="text text--inc">{cardName ? 'El pago de tus entradas está cubierto con tu' : ''}</p>
      <p className="text text--inc"> {cardName ? cardName + ' Cine Yelmo' : ''} </p>
    </div>
  );
};

const mapStateToProps = (state) => ({
  cardName: state.cards.cardList.length > 0 ? state.cards.cardList[0]?.parent_code === 'pase-anual' ? cardPaseAnualSelector(state).name : state.cards.cardList[0].type === 'loyalty' ? cardMovieYelmoSelector(state).name : 'OTRA PROMOCIÓN' : '',
  cardImage: state.cards.cardList.length > 0 ? state.cards.cardList[0]?.parent_code === 'pase-anual' ? cardPaseAnualSelector(state).images.reference : state.cards.cardList[0].type === 'loyalty' ? cardMovieYelmoSelector(state).images.reference : '' : '',
  cardNumber: state.cards.cardList.length > 0 ? state.cards.cardList[0] !== null ? state.cards.cardList[0]?.number.replace(/.(?=.{4,}$)/g, '*').match(/.{1,4}/g) : state.cards.cardList[0].type === 'loyalty' ? state.cards.cardList[0]?.number.replace(/.(?=.{4,}$)/g, '*').match(/.{1,4}/g) : [] : []
});

export default memo(connect(mapStateToProps)(PriceZero));
